const apiUrl = process.env.REACT_APP_API_URL;
export const GetAlumneNotes = async (id_alumne : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/alumnes/${id_alumne}/notes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
